'use client';
import React from 'react';
import MultiSelect from '@/components/ui/multi-select';
import { LazySection } from '@/components/ui/LazySection';

interface FilterOption {
  key: string;
  label: string;
  options: string[];
  selected: string[];
  setSelected: (v: string[]) => void;
  loading?: boolean;
}

interface ProductFilterBarProps {
  filters: FilterOption[];
}

export default function ProductFilterBar(props: ProductFilterBarProps) {
  return (
    <LazySection minHeight={60}>
      <div className="w-full mb-6">
        {/* Filter Grid - Responsive */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
          {props.filters.map((filter) => (
            <MultiSelect
              key={filter.key}
              options={filter.options.map((option) => ({ label: option, value: option }))}
              selected={filter.selected}
              onChange={filter.setSelected}
              placeholder={filter.label}
              disabled={filter.loading}
            />
          ))}
        </div>
      </div>
    </LazySection>
  );
}
